<template>
  <div class="total-amounts-wrapper w-100">
    <div class="retain-area row align-items-center pb-2">
      <div class="col">
        <custom-switch
          v-model="retainMyBetsModel"
          :id="'retainMyBets'"
          @change="retainMyBets"
          textNowrap="true"
          :text="$t('BetSlip.RetainMyBets')"
        ></custom-switch>
      </div>

      <div class="clear-all-area col">
        <div class="d-flex justify-content-end">
          <span
            class="clear-bet-slip d-flex align-items-center"
            v-if="betSlipBetCount > 0 || betOptionsStatus.error"
            @click="clearBetSlip()"
          >
            <!--            {{ $t('BetSlip.ClearBetSlip') }}-->

            <div class="ml-2 bet-slip-clear-icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15.5013 2.303H11.7583V1.76C11.7583 0.7895 10.8706 0 9.77934 0H6.22122C5.13001 0 4.2423 0.7895 4.2423 1.76V2.303H0.499227C0.222066 2.303 0 2.5005 0 2.747C0 2.9935 0.222066 3.191 0.499227 3.191H1.40155V13.625C1.40155 14.934 2.60014 16 4.07196 16H11.928C13.3999 16 14.5985 14.934 14.5985 13.625V3.191H15.5008C15.7779 3.191 16 2.9935 16 2.747C16 2.5005 15.7779 2.303 15.5008 2.303H15.5013ZM5.24132 1.7605C5.24132 1.28 5.68152 0.889 6.22122 0.889H9.77934C10.3196 0.889 10.7592 1.2805 10.7592 1.7605V2.3035H5.24076V1.7605H5.24132ZM13.6006 13.6255C13.6006 14.4445 12.8495 15.1125 11.9286 15.1125H4.07252C3.15165 15.1125 2.40056 14.4445 2.40056 13.6255V3.1915H13.6039V13.6255H13.6H13.6006Z"
                  fill="#070A14"
                />
                <path
                  d="M8.00069 13.5204C8.27785 13.5204 8.49992 13.3229 8.49992 13.0764V5.22794C8.49992 4.98144 8.27785 4.78394 8.00069 4.78394C7.72353 4.78394 7.50146 4.98144 7.50146 5.22794V13.0734C7.50146 13.3199 7.72353 13.5209 8.00069 13.5209V13.5204Z"
                  fill="#070A14"
                />
                <path
                  d="M4.74141 13.0303C5.01858 13.0303 5.24064 12.8328 5.24064 12.5863V5.71475C5.24064 5.46825 5.01858 5.27075 4.74141 5.27075C4.46425 5.27075 4.24219 5.46825 4.24219 5.71475V12.5863C4.24219 12.8328 4.46763 13.0303 4.74141 13.0303Z"
                  fill="#070A14"
                />
                <path
                  d="M11.2595 13.0303C11.5366 13.0303 11.7587 12.8328 11.7587 12.5863V5.71475C11.7587 5.46825 11.5366 5.27075 11.2595 5.27075C10.9823 5.27075 10.7603 5.46825 10.7603 5.71475V12.5863C10.7603 12.8328 10.9823 13.0303 11.2595 13.0303Z"
                  fill="#070A14"
                />
              </svg>
            </div>
          </span>
        </div>
      </div>

      <div class="col-12 mt-1">
        <custom-switch
          v-model="acceptOddChanges"
          :id="'acceptOddChanges'"
          :text="$t('BetSlip.AcceptAllOddChanges')"
        ></custom-switch>
      </div>
    </div>

    <div style="border-bottom: 1px solid #e8e8e8" class="mb-2"></div>

    <div class="row" data-id="BetSlip.Total Bets">
      <div class="title col-8">{{ $t('BetSlip.Total Bets') }}</div>
      <div class="title col ta-right">{{ totalBets }}</div>
    </div>
    <div class="row" data-id="BetSlip.Total Bet Amount">
      <div class="title col-8">{{ $t('BetSlip.Total Bet Amount') }}</div>
      <div class="title col ta-right"><price :val="totalRiskAmount" /></div>
    </div>

    <!-- TAX RELATED -->
    <div
      class="row title-row"
      v-if="!!parseFloat(totalRiskTaxAndFee) && taxShowCondition"
      data-id="BetSlip.RiskTaxAmount"
    >
      <div class="title col-8">{{ $t('BetSlip.RiskTaxAmount', { indic: $taxHelper.totalTaxIndic().risk }) }}</div>
      <div class="title col ta-right"><price :val="totalRiskTaxAndFee" /></div>
    </div>
    <div class="row title-row" v-if="!!parseFloat(totalRiskTaxAndFee) && taxShowCondition" data-id="BetSlip.RiskCost">
      <div class="title col-8">{{ $t('BetSlip.RiskCost') }}</div>
      <div class="title col ta-right"><price :val="totalRiskCost" /></div>
    </div>
    <!-- /TAX RELATED -->

    <div class="row title-row" v-if="!hideTotalWinAmount" data-id="BetSlip.Potential Win Amount">
      <div class="title col-8">{{ $t('BetSlip.Potential Win Amount') }}</div>
      <div class="title col ta-right"><price :val="potentialWinAmount" /></div>
    </div>

    <!-- TAX RELATED -->

    <div
      class="row title-row"
      v-if="!!parseFloat(totalWinTaxAndFee) && taxShowCondition"
      data-id="BetSlip.WinTaxAmount"
    >
      <div class="title col-8">{{ $t('BetSlip.WinTaxAmount', { indic: $taxHelper.totalTaxIndic().win }) }}</div>
      <div class="title col ta-right"><price :val="totalWinTaxAndFee" /></div>
    </div>
    <div
      class="row title-row"
      v-if="!!parseFloat(totalWinTaxAndFee) && taxShowCondition"
      data-id="BetSlip.WinFeeAmount"
    >
      <div class="title col-8">{{ $t('BetSlip.Pay') }}</div>
      <div class="title col ta-right"><price :val="totalPayAmount" /></div>
    </div>
    <!-- /TAX RELATED -->

    <free-play-option v-if="showFreePlayIfEligible && loginType === LoginTypes.Player"></free-play-option>

    <div class="d-flex">
      <div
        class="d-flex align-items-end w-100"
        v-if="acceptOddChanges === false ? !isAnyOddChanged : !(isAnyOddChanged && acceptOddChanges)"
      >
        <place-bet-button
          ref="placeBetButton"
          v-if="freeWagersViewing === false"
          :betOptionsResponse="betOptionsResponse"
          :totalRiskAmount="totalRiskCost"
          :totalBets="totalBets"
          :disablePlaceBetButton="disablePlaceBetButton"
          :wagerType="wagerType"
          @clicked="setTotalRiskWithoutTaxMethod"
        ></place-bet-button>
        <place-bet-button-free-wager
          ref="placeBetButton"
          v-else-if="freeWagersViewing === true"
          :betOptionsResponse="betOptionsResponse"
          :totalBets="totalBets"
          :disablePlaceBetButton="disablePlaceBetButton"
          @clicked="setTotalRiskWithoutTaxMethod"
        ></place-bet-button-free-wager>
      </div>
      <div v-else class="w-100">
        <alert-message default withoutIcon :title="$t('BetSlip.OddsChanged')" />

        <div class="bet-slip-selection-accept-wrapper mt-2 pb-2">
          <button class="btn btn-lg btn-orange w-100 special-place-bet-btn" @click="innerAccept()">
            {{ $t('BetSlip.AcceptAll') }}
          </button>
        </div>
      </div>
    </div>
    <p class="text-center mt-2" style="font-size: 11px">{{$t('BetSlip.ConfirmSelections')}}</p>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import PlaceBetButton from './PlaceBetButton';
import PlaceBetButtonFreeWager from './PlaceBetButtonFreeWager';
import FreePlayOption from './FreePlayOption';
import { LoginTypes } from '@/utils/enums';
import { roundAmount } from '@/views/sports/components/bet-slip/bet-slip-utils';
import { mapFields } from 'vuex-map-fields';

export default {
  props: [
    'totalBets',
    'totalRiskAmount',
    'totalRiskAmountWithoutTax',
    'totalWinAmount',
    'hideTotalWinAmount',
    'showFreePlayIfEligible',
    'betOptionsResponse',
    'disablePlaceBetButton',
    'potentialReturnAmountForIfBet',
    'wagerType',
    'fixedParlayMultiply',
  ],
  components: {
    PlaceBetButton,
    PlaceBetButtonFreeWager,
    FreePlayOption,
  },
  data() {
    return {
      LoginTypes,
      retainMyBetsModel: null,
    };
  },
  methods: {
    ...mapMutations('betSlip', ['acceptAllOddsChange']),
    ...mapMutations('betSlip', ['openBetSlip']),
    ...mapMutations('betSlip', ['setTotalRiskWithoutTax']),
    ...mapActions({
      clearBetSlip: 'betSlip/clearBetSlip',
      retainBets: 'betSlip/retainBets',
    }),
    retainMyBets(retainBetsValue) {
      this.retainBets(retainBetsValue);
    },
    setTotalRiskWithoutTaxMethod() {
      this.setTotalRiskWithoutTax(this.totalRiskAmountWithoutTax);
    },
    innerAccept() {
      this.acceptAllOddsChange();
      // setTimeout(() => {
      //   this.$refs.placeBetButton.tryPlaceBet();
      // }, 10);
    },
  },
  computed: {
    ...mapState('player', ['loginType']),
    ...mapState('freeWagerStore', ['freeWagersViewing']),
    ...mapGetters('betSlip', ['isAnyOddChanged']),
    ...mapFields('betSlip', ['acceptOddChanges']),
    ...mapState({
      activeFreeBet: (state) => state.betSlip.activeFreeBet,
      betSlipBetCount: (state) => state.betSlip.betSlipBetCount,
      betOptionsStatus: (state) => state.betSlip.betOptionsStatus,
    }),
    betType() {
      return this.wagerType;
    },
    applyTax() {
      return this.$taxHelper.mustApplyTax;
    },
    taxShowCondition() {
      return this.applyTax && parseFloat(this.totalRiskAmount) > 0;
    },
    totalWinTaxAndFee() {
      if(this.betType==='parlay'){
        return this.$taxHelper.calculatedWinTaxes(this.totalWinAmount, this.totalBets);
      }
      // if (this.betOptionsResponse.fixedParlayMultiply)

      return this.$taxHelper.calculatedWinTaxes(this.totalWinAmount - this.totalRiskAmount, this.totalBets);
    },
    potentialWinAmount() {
      if (this.betType === 'if_win') {
        return this.potentialReturnAmountForIfBet;
      } else if (this.betType == 'teaser') {
        return  this.totalWinAmount - this.totalRiskAmount;
      } else if (this.betType === 'parlay') {
        return roundAmount(this.totalWinAmount);
      }
      return roundAmount(this.totalWinAmount - this.totalRiskAmount);
      return this.activeFreeBet ? roundAmount(this.totalWinAmount - this.totalRiskAmount) : this.totalWinAmount;
    },
    totalRiskTaxAndFee() {
      return this.$taxHelper.calculatedRiskTaxes(this.totalRiskAmount, this.totalBets);
    },
    totalRiskCost() {
      return this.$taxHelper.totalRiskCost(this.totalRiskAmount, this.totalBets, this.totalRiskAmount);
    },
    totalPayAmount() {
      return roundAmount(
        parseFloat(this.totalRiskAmount) + parseFloat(this.potentialWinAmount) - parseFloat(this.totalWinTaxAndFee),
      );
    },
    oddChangedCondition() {
      return this.acceptOddChanges === true ? this.isAnyOddChanged && this.acceptOddChanges : this.isAnyOddChanged;
    },
  },
  watch: {
    acceptOddChanges(newVal, oldVal) {
      if (newVal === true) {
        this.acceptAllOddsChange();
      }
    },
  },
};
</script>

<style lang="scss">
.total-amounts-wrapper {
  padding: 9px 10px;
  margin-top: 15px;
  background-color: var(--color4) !important;
  border-radius: 4px;
  font-size: 12px !important;
  font-weight: bold;

  .switch span {
    font-weight: bold !important;
  }

  .free-play-area {
    color: #747474 !important;
  }

  .title-row {
    margin-bottom: 6px;
  }

  .bet-slip-line-subheader {
    background-color: var(--color4) !important;
    color: #000;
  }

  @media (min-width: 1024px) and (max-width: 1440px) {
    margin-bottom: 100px;

    .kiosk & {
      //margin-bottom: 0;
    }
  }

  .line-header {
    min-height: 30px;

    .title {
      font-size: 12px !important;
    }
  }

  .clear-bet-slip {
    cursor: pointer;

    .bet-slip-clear-icon {
      margin-top: -2px;
    }
  }

  .ta-right {
    text-align: right;
  }
}

.retain-area {
}

.set-amount-all-bets-input {
  padding-bottom: 0 !important;

  .kiosk & {
    padding-bottom: 0.5rem !important;
  }

  .input-span {
    font-weight: bold;
  }
}
</style>
